import { useSelector } from "react-redux";
import "../App.css";
import constants from "../static/constants.json";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { Box } from "@mui/material";
import Container from "../common/Container";
import Hero from "../components/Home/Hero";
import Highlights from "../components/Home/Highlights";
import Features from "../components/Home/Features";
import Footer from "../components/Home/Footer";
function Home() {
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();

  // const theme = useTheme()
 

  const notSignedInContent = (
    <Box>
      <Box position={'relative'}>
        <Container position="relative" zIndex={2}>
          <Hero />
        </Container>
      </Box>
      <Container>
        <Highlights />
      </Container>
      <Container>
        <Features />
      </Container>
      {/* <Box bgcolor={theme.palette.alternate.main}>
        <Container>
          <DemoPages />
        </Container>
      </Box> */}
      <Container>
        <Footer />
      </Container>
    </Box>
  );

  useEffect(() => {
    if (user && user.id) {
      if (user.personTypeId === constants.personType.worker) {
        // todo, if no jobs, send the worker to jobs
        navigate("/assignments");
      } else {
        navigate("/jobs");
      }
    }
  }, [user]); //eslint-disable-line

  return <div className="App">{(!user || !user.id) && notSignedInContent}</div>;
}

export default Home;
